var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector-list"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"each-select",on:{"click":function($event){return _vm.onSelect(item.id)}}},[_c('p',{class:[
                Number(item.id) === Number(_vm.current) ? 'active' : ''
            ]},[_vm._v(_vm._s(item.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }